var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.58l1.41-1.42 1.42 1.42L1.41 10z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgZmlsbD0iIzAwNGE4NSI+CiAgICA8cGF0aCBkPSJNMCA4LjU4bDEuNDEtMS40MiAxLjQyIDEuNDJMMS40MSAxMHoiIGZpbGw9IiMwMDRhODUiIC8+Cjwvc3ZnPgo=";
export { SvgExternalDot as ReactComponent };